module.exports = __webpack_public_path__ + "static/img/product-Business-Credit-Reports-img-768x570.99de060c.png";